module.exports = __webpack_public_path__ + "static/media/icon-select-green.e7c9cae6.svg";